<template>
  <aside id="text-4" class="widget widget_text">
    <div class="h3 widgettitle">{{ $t('forContactUs') }}</div>
    <div class="textwidget">
      <ul>
        <li>
          <a href="mailto:apptown.info@gmail.com">
            <i class="far fa-envelope" style="margin-right: 5px"></i>
            apptown.info@gmail.com
          </a>
        </li>
        <li>
          <a href="tel:+380731430022" class="binct-phone-number-1">
            <i
              class="fa fa-phone"
              style="margin-right: 5px"
              aria-hidden="true"
            ></i>
            +38 (073) 143-00-22
          </a>
        </li>
        <li>
          <a href="tel:+380961430055" class="binct-phone-number-2">
            <i
              class="fa fa-phone"
              style="margin-right: 5px"
              aria-hidden="true"
            ></i>
            +38 (096) 143-00-55
          </a>
        </li>
        <li>
          <a
            href="https://instagram.com/apptown.ua?utm_source=ig_profile_share&amp;igshid=cw4f11iy3nfa"
            class="seasidetms_social_icon_1 seasidetms-icon-custom-instagram"
            title="@apptown.ua"
            target="_blank"
            style="font-size: 18px"
            rel="noopener noreferrer"
          >
            @apptown.ua
          </a>
        </li>
        <li>
          <a
            href="https://www.facebook.com/apptown.vn/"
            title="facebook.com/apptown.vn"
            target="_blank"
            rel="noopener noreferrer"
            class="seasidetms_social_icon_1 seasidetms-icon-facebook"
            style="font-size: 18px"
          >
            @apptown.vn
          </a>
        </li>
        <li>
          <router-link :to="lang ? '/' + lang + '/sitemap' : '/sitemap'">
            - Карта сайта
          </router-link>
        </li>
      </ul>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'FooterInfoMenu',
  data() {
    return {
      lang: '',
    }
  },
  beforeMount() {
    this.lang = this.$store.getters.lang
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
}
</script>

<style></style>
